import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { AccessibilityPopup, AccessibilityClickableDiv, AccessibilityHiddenImg } from '@skillz/accessibility';
import { logout } from "../../../../../store/auth-actions";
import userProfile from "../../../../../assests/icons/userProfile.png"
import TranslateBtns from "../../../../ui/translateBtns/TranslateBtns";
import Text from "../../../../shared/text/Text";
import ThemeToggle from "../../../../ui/themeToggle/ThemeToggle";
import Icon from "../../../../ui/icons/Icon";
import iconsList from "../../../../ui/icons/iconsList";
import BlockScreen from "../../../../ui/blockScreen/BlockScreen";
import classes from './UserDetails.module.css'

const UserDetails = ({ close }) => {

    const { name } = useSelector(state => state.auth.user);
    const { texts } = useSelector(state => state.translate);
    const { isStudent, userDetails } = useSelector(state => state.auth);
    const dispatch = useDispatch();

    return (
        <div className={classes.UserDetails} >
            <BlockScreen />
            <AccessibilityClickableDiv className={classes.Close} onClick={() => close && close()} accessibilityDescription={texts.close}>
                <Icon size="36px" name={iconsList.close} />
            </AccessibilityClickableDiv>
            <div className={classes.UserProfile}>
                <AccessibilityHiddenImg src={userProfile} />
            </div>

            <p className={classes.UserName}>{name}</p>

            <div className={classes.Line}></div>

            <div className={classes.DetailsWrapper}>
                {isStudent ?
                    <div className={classes.Details}> <p>{userDetails?.defaultSchool?.name}</p> </div>
                    :
                    <div className={classes.TeacherSchools}>
                        {userDetails?.schools?.map((school, index) => <p key={index}>{school.name}, {school.city}</p>)}
                    </div>
                }
            </div>
            <ThemeToggle />
        </div>
    )
}

export default UserDetails;